import React from 'react'
import ErrorBoundaryIcon from 'Components/Icons/ErrorBoundary'

const UnderService = () => (
  <div className="min-h-[40vh] flex flex-col justify-center items-center mx-auto mt-12 max-h-[70vh] text-center [&>svg]:my-8 [&>p]:mb-2 md:max-h-[60vh]">
    <ErrorBoundaryIcon />
    <h1 className="text-[30px] font-bold text-black mb-4">
      System is under maintenance
    </h1>
    <p className="text-lg text-muted-foreground pb-[60px] max-w-[540px] mt-0">
      We&apos;re preparing to serve you better.
    </p>
  </div>
)

export default UnderService
